<template>
  <ConclusionStep status="positive" :title="withdrawTitle" :show-navbar="false">
    <section class="main">
      <div class="main__list">
        <ListDisplay
          v-for="(review, index) in infoCompletedWithdraw?.review"
          :key="index"
          class="list-item"
          :title="review.label"
          :value="review.value"
          :has-divider="
            index !== (infoCompletedWithdraw?.review?.length ?? 0) - 1
          "
        />
      </div>

      <MessageFoundation>
        <template #description>
          O <strong>valor líquido do resgate é uma estimativa</strong> e pode
          variar conforme cotação, impostos e taxas no dia da liquidação.
        </template>
      </MessageFoundation>
    </section>

    <template #button-primary>
      <ButtonPrimary
        label="Voltar para carteira"
        size="large"
        @click="handleNextClick"
      />
    </template>
  </ConclusionStep>
</template>

<script lang="ts" setup>
import { isImpersonate } from '@/modules/common/services/partner';
import { WealthPortfolioTabs } from '@/modules/wealth/views/WealthPortfolioV2/types';
import { computed, inject, Ref } from 'vue';
import { useRoute, useRouter } from 'vue-router/composables';
import { IWithdrawSummary } from '@/modules/transaction/services/withdraw-by-portfolio';
import {
  ButtonPrimary,
  ConclusionStep,
  ListDisplay,
  MessageFoundation
} from '@warrenbrasil/nebraska-web';

import { PortfolioCategories } from '@/types/models/Portfolio';

const infoCompletedWithdraw = inject('withdrawReview') as Ref<IWithdrawSummary>;

const route = useRoute();
const router = useRouter();

const portfolioId = computed(() => {
  return route.params.id as string;
});

const withdrawTitle = computed(() =>
  isImpersonate() ? 'Sugestão de resgate enviada' : 'Resgate solicitado'
);

function handleNextClick() {
  router.push({
    name: 'wealthPortfolio',
    params: {
      id: portfolioId.value,
      type: PortfolioCategories.WarrenManagement
    },
    query: {
      tab: WealthPortfolioTabs.Orders
    }
  });
}
</script>

<style scoped lang="less">
.main {
  margin: 0 auto;
  max-width: 592px;
  display: flex;
  flex-direction: column;
  padding: @size-spacing-x700 @size-spacing-x400 0 @size-spacing-x400;

  &__list {
    display: flex;
    flex-direction: column;
    gap: @size-spacing-x400;
    padding-bottom: @size-spacing-x600;
  }
}
</style>
